var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","fixed":"","bottom":"","right":"","dark":"","fab":""},on:{"click":function($event){return _vm.setCreateDialog(true)}}},[_c('v-icon',{attrs:{"size":"28"}},[_vm._v(" mdi-plus ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }